import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { DeviceModels, GetRayDeviceGuide, SpecialityTypes } from '../../config/RayCodes';
import { InputBasicTextArea } from '../../components/common/Inputs';
import { FileAddList } from '../../components/common/FileAddList';
import { SiteSurveyAction, RayCodeAction, ProductAction } from '../../actions';
import { RayForm, RayFormValidation } from '../common';
import { useTranslation } from 'react-i18next';
import { FileItem, FileUpload } from '../common/FileUpload';
import { Translate as t } from '../../config/Translate';
import { formatDisplayDateTime } from '../../lib/dateDisplay';

import { isPreviewable } from '../../utils/filePreview';

const SurveyStep3 = ({ Update, info, isSummary = false, Attachment, gostep, clist, onPreview, onDownload, onDownloadAll }) => {
	// const [ t, i18n ] = useTranslation();
	const [siteSurvey, setSiteSurvey] = useState({ attachments: [], ...info, siteSurveyStep: 5 });
	const [roomdimensions, setRoomDimension] = useState({
		space: "",
		img: ""
	});

	useEffect(() => {
		if (gostep) {
			if (gostep.curStep == 4) {
				Update(siteSurvey._id, { ...siteSurvey, siteSurveyStep: gostep.goStepNo });
			}
		}
	}, [gostep])

	useEffect(() => {
		setSiteSurvey({ attachments: [], ...info });
	}, [info]);

	const Prev = (e) => {
		Update(siteSurvey._id, { ...siteSurvey, siteSurveyStep: 3 });
	};

	const [isSubmitting, setIsSubmitting] = useState(false);

	const validNext = async () => {
		setIsSubmitting(true);
		try {
			await Update(siteSurvey._id, { ...siteSurvey, siteSurveyStep: 5 });
		} catch (error) {
			console.error('SurveyStep3 validNext error:', error);
		} finally {
			setIsSubmitting(false);
		}
	};

	useEffect(() => {
		if (siteSurvey.model) {
			const x = clist?.filter(x => x.type === 'PRODUCTOPTION' && x.group === siteSurvey.model && x.code === siteSurvey.option);
			if (x?.length > 0) {
				setRoomDimension(GetRayDeviceGuide(x[0].model, x[0].option));
			} else {
				setRoomDimension(GetRayDeviceGuide("", ""));
			}
			//});
		} else {
			setRoomDimension(GetRayDeviceGuide("", ""));
		}
	}, [siteSurvey, clist]);

	const filelist = (list) => {
		setSiteSurvey({ ...siteSurvey, ["attachments"]: list });
	}
	const handleChangeData = (e) => {
		const { name, value } = e.target;
		setSiteSurvey({ ...siteSurvey, [name]: value });
	}

	const setNewFile = (file, fileType) => {
		Attachment(siteSurvey._id, "ADD", {
			...siteSurvey,
			name: file.original,
			path: file.s3path,
			attachmentType: fileType
		});
	};

	const delFile = (c) => {
		Attachment(siteSurvey._id, "DEL", {
			...siteSurvey,
			delAttachid: c._id
		});
	};

	return (
		<>
			{!isSummary && <div className={isSummary ? "" : "section mt-1"}>
				<div className={isSummary ? "section-title bdB2" : "section-title"}>{t('installation.field.roomDimensions')}</div>
				<blockquote className="blockquote mt-1">
					<p className="mb-0">{t('installation.label.roomWarning1')}</p>
				</blockquote>
				<blockquote className="blockquote">
					<p className="mb-0">{t('installation.label.roomWarning2')}</p>
				</blockquote>
			</div>}
			{!isSummary &&
				<div className={isSummary ? "" : "section mt-1"}>
					<div className={isSummary ? "section-title bdB2" : "section-title"}>{t('installation.field.minimumSpace')}</div>
					<div className="card">
						<div className="card-body">
							<div>
								<div><p style={{ whiteSpace: 'pre-line' }}> {roomdimensions.space.replace("Width door", t('installation.field.widthDoor')).replace("Width", t('common.field.width')).replace("Depth", t('common.field.depth')).replace("Height", t('common.field.height'))} </p></div>
							</div>
							<div>
								<img src={roomdimensions.img} className="img-fluid" />
							</div>
						</div>
					</div>
				</div>
			}
			<div className={isSummary ? "" : "section mt-1"}>
				{!isSummary && <div className="section-title">{t('common.label.attachments')}</div>}
				{isSummary && (
					<div className="section-title bdB2 d-flex align-items-center justify-content-between">
						<span>{t('common.label.attachments')}</span>
						{onDownloadAll && siteSurvey.attachments.filter(p => p.type === "room").length > 0 && (
							<button className="btn btn-sm btn-outline-primary mt-0"
								onClick={() => onDownloadAll(siteSurvey.attachments.filter(p => p.type === "room"))}>
								<ion-icon name="download-outline"></ion-icon> {t('common.button.downloadAll') || 'Download All'}
							</button>
						)}
					</div>
				)}
				{!isSummary &&
					<>
						<div className="card">
							<div className="card-body">
								<FileUpload
									option={{ doneandnew: true, label: t('common.button.selectAFile') }}
									extraData={{ path: "siteSurvey/" + siteSurvey._id + "/" }}
									callback={(e) => setNewFile(e, "room")}
								/>
							</div>
						</div>
						{onPreview ? (
							<ul className="listview">
								{siteSurvey.attachments.map((p, idx) => {
									if (p.type !== "room") return null;
									return (
										<li key={p._id} className="border-bottom py-2">
											<div className="d-flex align-items-center justify-content-between">
												<div style={{ flex: 1, minWidth: 0 }}>
													{isPreviewable(p.name) ? (
														<button type="button" className="btn btn-link p-0 text-primary text-decoration-none"
															onClick={() => onPreview(p)}>
															<strong>{p.name}</strong>
														</button>
													) : (
														<strong>{p.name}</strong>
													)}
													{p.createDate > 0 && (
														<span className="text-muted ms-2" style={{ fontSize: '0.85em' }}>
															{formatDisplayDateTime(p?.createDate)}
														</span>
													)}
												</div>
												<div className="d-flex align-items-center ms-2">
													{isPreviewable(p.name) && (
														<button className="btn btn-sm btn-outline-primary me-1 mt-0"
															onClick={() => onPreview(p)}
															title={t('common.button.preview') || 'Preview'}>
															<ion-icon name="eye-outline"></ion-icon>
														</button>
													)}
													{onDownload && (
														<button className="btn btn-sm btn-outline-dark me-1 mt-0"
															onClick={() => onDownload(p)}
															title={t('common.button.download') || 'Download'}>
															<ion-icon name="download-outline"></ion-icon>
														</button>
													)}
													<button className="btn btn-sm btn-danger mt-0"
														onClick={() => delFile(p)}
														title={t('common.button.delete') || 'Delete'}>
														<ion-icon name="trash-outline"></ion-icon>
													</button>
												</div>
											</div>
										</li>
									);
								})}
							</ul>
						) : (
							<ul className="list-group">
								{siteSurvey.attachments.map((p) =>
									p.type === "room" &&
									<li className='list-group-item ps-1' key={p._id}>
										<FileItem fileInfo={{ ...p, original: p.name, s3path: p.path }} callback={(p) => delFile(p)} />
									</li>
								)}
							</ul>
						)}
					</>
				}
				{isSummary && <ul className="listview">
					{siteSurvey.attachments.map((p, idx) => {
						if (p.type !== "room") return null;
						return (
							<li key={p._id} className="border-bottom py-2">
								<div className="d-flex align-items-center justify-content-between">
									<div style={{ flex: 1, minWidth: 0 }}>
										{isPreviewable(p.name) && onPreview ? (
											<button type="button" className="btn btn-link p-0 text-primary text-decoration-none"
												onClick={() => onPreview(p)}>
												<strong>{p.name}</strong>
											</button>
										) : (
											<strong>{p.name}</strong>
										)}
										{p.createDate > 0 && (
											<span className="text-muted ms-2" style={{ fontSize: '0.85em' }}>
												{formatDisplayDateTime(p?.createDate)}
											</span>
										)}
									</div>
									<div className="d-flex align-items-center ms-2">
										{isPreviewable(p.name) && onPreview && (
											<button className="btn btn-sm btn-outline-primary me-1 mt-0"
												onClick={() => onPreview(p)}
												title={t('common.button.preview') || 'Preview'}>
												<ion-icon name="eye-outline"></ion-icon>
											</button>
										)}
										{onDownload && (
											<button className="btn btn-sm btn-outline-dark me-1 mt-0"
												onClick={() => onDownload(p)}
												title={t('common.button.download') || 'Download'}>
												<ion-icon name="download-outline"></ion-icon>
											</button>
										)}
										<button className="btn btn-sm btn-danger mt-0"
											onClick={() => delFile(p)}
											title={t('common.button.delete') || 'Delete'}>
											<ion-icon name="trash-outline"></ion-icon>
										</button>
									</div>
								</div>
							</li>
						);
					})}
				</ul>}
			</div>
			<div className={isSummary ? "" : "section mt-1"}>
				<div className={isSummary ? "section-title bdB2" : "section-title"}>{t('service.field.finalComment')}</div>
				{!isSummary && <div className="card">
					<div className="card-body">
						<InputBasicTextArea
							options={{ val: siteSurvey.finalComment, name: "finalComment", label: t('common.field.comment') }}
							editable={!isSummary}
							isForm={true}
							onchange={handleChangeData} />
					</div>
				</div>}
				{isSummary && <div className="pb-1 pt-1">
					<InputBasicTextArea
						options={{ val: siteSurvey.finalComment, name: "finalComment", label: t('common.field.comment') }}
						editable={!isSummary}
						isForm={true}
						onchange={handleChangeData} />
				</div>}
			</div>
			{!isSummary &&
				<div className="section mt-1 mb-2">
					<button className={isSubmitting ? "btn btn-primary btn-block btn-lg disabled" : "btn btn-primary btn-block btn-lg"} onClick={() => !isSubmitting && validNext()}>{isSubmitting ? t('common.status.processing') || 'Processing...' : t('common.button.next')}</button>
					<button className="btn btn-dark btn-block btn-lg mt-1" onClick={() => Prev()}>{t('common.button.prev')}</button>
				</div>
			}
		</>
	);
};

const mapState = (state) => {
	const clist = state.RayCodeReducer.items;
	return { clist };
};

const mapDispatch = (dispatch) => ({
	Update: (_id, data) => dispatch(SiteSurveyAction.UpdateSiteSurvey(_id, data)),
	Attachment: (_id, type, data) => dispatch(SiteSurveyAction.Attachment(_id, type, data)),
});

export default connect(mapState, mapDispatch)(SurveyStep3);